import { Card, Muted, Spinner, Tag, fmtDate, useAsync } from '../../ui.jsx';
import { adminApi } from '../../api/endpoints.js';

const tone = { open: 'mid', accepted: 'ok', declined: 'no', released: '', expired: 'no' };

export default function AdminOffers() {
  const { data, loading, error } = useAsync(() => adminApi.offers(), []);

  if (loading) return <Spinner label="Loading offers" />;
  if (error) return <div className="note">We could not load offers. Please try again.</div>;

  const offers = data?.offers || [];

  return (
    <>
      <h2>Offers</h2>
      <Muted>
        An applicant has a set number of days to respond. Accepting one offer releases the rest.
      </Muted>

      {offers.length === 0 ? (
        <Card>
          <Muted>You have not made any offers yet.</Muted>
        </Card>
      ) : (
        <Card>
          <div className="scroll-x">
            <table className="tbl">
              <thead>
                <tr>
                  <th>Applicant</th>
                  <th>Programme</th>
                  <th>Mode</th>
                  <th>Expires</th>
                  <th>Status</th>
                  <th>Letter reference</th>
                </tr>
              </thead>
              <tbody>
                {offers.map((offer) => (
                  <tr key={offer.id}>
                    <td>
                      <b>{offer.applicant.name}</b>
                      <div className="mu">{offer.applicant.email}</div>
                    </td>
                    <td>{offer.programme}</td>
                    <td>{offer.mode}</td>
                    <td>
                      {fmtDate(offer.expiresAt)}
                      {offer.respondedAt ? <div className="mu">Answered {fmtDate(offer.respondedAt)}</div> : null}
                    </td>
                    <td>
                      <Tag tone={tone[offer.status]}>{offer.status}</Tag>
                    </td>
                    <td>{offer.letterReference || <span className="mu">Not issued</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </>
  );
}
